import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import ProgramFileUploadComponent from "../programFileUpload/programFileUpload";
import { IFoundationProgramFileProps } from "./foundationProgramModels";

import moment from "moment";
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { LoadingButton } from "@mui/lab";
import FoundationProgramService from "./foundationProgramService";
import { FileTypeIcon } from "../../common/components/FileTypeIcon";
import { useProgramDetailsContext } from "./foundationProgramContext";
import React, { useState } from "react";
import { getFileNameWithOutExt } from "../../common/utilities/utils";
import { IFoundationProgramFile } from "../../common/models/foundationProgram";



export const FoundationProgramFiles = (props: IFoundationProgramFileProps) => {
    const { handleFileChange, handleDelete, programFiles, fileUploadIsInProgress, tableSxProps } = props;
    const programDetailsContext = useProgramDetailsContext();

    const handleDownloadClick = (programFile: IFoundationProgramFile) => {
        const fileDownloadUrl = FoundationProgramService.getFileDownloadUrl(programFile.fileId);
        window.open(fileDownloadUrl, '_blank');
    }
    return (
        <>
            {(programDetailsContext.isAddFilesVisible === true) && <ProgramFileUploadComponent handleFileChange={handleFileChange} fileUploadIsInProgress={fileUploadIsInProgress}></ProgramFileUploadComponent>}
            <TableContainer sx={{
                width: "100%",
                maxHeight: "70vh",
                minHeight: "70vh",
                overflowY: "auto",
                ...tableSxProps
            }}>
                <Table sx={{ minWidth: 650 }} aria-label="files table" stickyHeader className="oe-files-bg">
                    <TableHead>
                        <TableRow sx={{ bgcolor: 'grey.50' }}>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em' }}>File Name</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Uploaded Date</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {programFiles.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={3} align="center">
                                    <Typography color="text.secondary" sx={{ py: 4 }}>No files uploaded yet.</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {programFiles.map((programFile) => (
                                <TableRow key={programFile.fileId} sx={{ '&:hover': { bgcolor: 'action.hover' } }}>
                                    <TableCell style={{ maxWidth: '50%' }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <FileTypeIcon fileName={programFile.fileName} />
                                            <Typography sx={{ fontSize: '0.875rem' }}>{getFileNameWithOutExt(programFile.fileName)}</Typography>
                                        </Stack>
                                    </TableCell>
                                    <TableCell sx={{ color: 'text.secondary', fontSize: '0.8rem' }}>{moment(programFile.createdDate).format('DD-MMM-YYYY HH:mm')}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        <Stack direction="row" spacing={1}>
                                            <LoadingButton
                                                variant="contained"
                                                size="small"
                                                startIcon={<CloudDownloadIcon />}
                                                onClick={() => handleDownloadClick(programFile)}
                                            >
                                                Download
                                            </LoadingButton>
                                            {(programDetailsContext.isDeleteFilesVisible === true) && (
                                                <LoadingButton
                                                    loading={programFile.isDeleteInProgress}
                                                    variant="outlined"
                                                    color="error"
                                                    size="small"
                                                    startIcon={<DeleteIcon />}
                                                    loadingPosition="start"
                                                    onClick={() => {
                                                        if (window.confirm(`Delete "${getFileNameWithOutExt(programFile.fileName)}"?`)) {
                                                            handleDelete(programFile);
                                                        }
                                                    }}
                                                >
                                                    Delete
                                                </LoadingButton>
                                            )}
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}

                    </TableBody>
                </Table>
            </TableContainer>

        </>
    );
}